var __require = /* @__PURE__ */ ((x) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x, {
  get: (a, b) => (typeof require !== "undefined" ? require : a)[b]
}) : x)(function(x) {
  if (typeof require !== "undefined")
    return require.apply(this, arguments);
  throw new Error('Dynamic require of "' + x + '" is not supported');
});

// src/toSlug.ts
function toSlug(str) {
  let s = str;
  if (!s) {
    return "";
  }
  s = s.toLowerCase().trim();
  s = s.replace(/ & /g, " and ");
  s = s.replace(/[ ]+/g, "-");
  s = s.replace(/[-]+/g, "-");
  s = s.replace(/[^a-z0-9-]+/g, "");
  return s;
}

// src/wait.ts
var wait = (duration, callback) => new Promise((resolve) => {
  setTimeout(() => resolve(callback?.()), duration);
});

// src/flatten-object/index.ts
var flattenObject = (obj) => {
  const toReturn = {};
  Object.keys(obj).forEach((key) => {
    const item = obj[key];
    if (!(key in obj))
      return;
    if (typeof item === "object" && item !== null) {
      const flatObject = flattenObject(item);
      Object.keys(flatObject).forEach((flattedKey) => {
        if (!(flattedKey in flatObject))
          return;
        toReturn[`${String(key)}.${flattedKey}`] = flatObject[flattedKey];
      });
    } else {
      toReturn[key] = item;
    }
  });
  return toReturn;
};

// src/number/clamp/clamp.ts
var clamp = (value, min = 0, max = 1) => {
  return Math.min(Math.max(min, value), max);
};

// src/number/percent/percent.ts
var valueToPercent = (value, min, max) => {
  return (value - min) * 100 / (max - min);
};
var percentToValue = (percent, min, max) => {
  return (max - min) * percent + min;
};

// src/assertions/is-browser/is-browser.ts
var isBrowser = () => typeof window !== "undefined";

// src/number/random/random.ts
function getRandomValues(buf) {
  if (isBrowser()) {
    if (window.crypto && window.crypto.getRandomValues) {
      return window.crypto.getRandomValues(buf);
    }
    if (typeof window.msCrypto === "object" && typeof window.msCrypto.getRandomValues === "function") {
      return window.msCrypto.getRandomValues(buf);
    }
  }
  if (!isBrowser()) {
    const nodeCrypto = __require("crypto");
    const bytes = nodeCrypto.randomBytes(buf.length);
    buf.set(bytes);
    return buf;
  }
  throw new Error("No secure random number generator available.");
}
var crandom = () => {
  return getRandomValues(new Uint8Array(1))[0] / Math.pow(2, 8);
};
var randomInt = (min, max) => {
  const minValue = Math.ceil(min);
  const maxValue = Math.floor(max);
  return Math.floor(Math.random() * (maxValue - minValue + 1)) + minValue;
};
var MAX_ITERATIONS = 100;
var crandomInt = (min, max) => {
  const minValue = Math.ceil(min);
  const maxValue = Math.floor(max);
  const range2 = maxValue - minValue + 1;
  const bitsNeeded = Math.ceil(Math.log2(range2));
  const bytesNeeded = Math.ceil(bitsNeeded / 8);
  const maxRange = 256 ** bytesNeeded;
  const cutoff = Math.floor(maxRange / range2) * range2;
  const bytes = new Uint8Array(bytesNeeded);
  let value;
  let iterations = 0;
  do {
    getRandomValues(bytes);
    value = bytes.reduce((acc, x, n) => acc + x * 256 ** n, 0);
    if (iterations >= MAX_ITERATIONS) {
      console.warn("Too many iterations. Check your source of randomness.");
      break;
    }
    iterations++;
  } while (value >= cutoff);
  return minValue + value % range2;
};

// src/number/lerp/lerp.ts
var lerp = (from, to, point) => from * (1 - point) + to * point;

// src/number/invlerp/invlerp.ts
var invlerp = (from, to, point) => clamp((point - from) / (to - from));

// src/shuffle/shuffle.ts
var shuffle = (array) => {
  let j;
  let temp;
  for (let i = array.length - 1; i > 0; i--) {
    j = Math.floor(Math.random() * (i + 1));
    temp = array[j];
    array[j] = array[i];
    array[i] = temp;
  }
  return array;
};
var cshuffle = (array) => {
  let j;
  let temp;
  for (let i = array.length - 1; i > 0; i--) {
    j = crandomInt(0, i);
    temp = array[j];
    array[j] = array[i];
    array[i] = temp;
  }
  return array;
};

// src/create-defer/create-defer.ts
function createDefer() {
  const defer = {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    resolve: () => {
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    reject: () => {
    },
    // @ts-expect-error it will be set later
    promise: null
  };
  defer.promise = new Promise((rs, rj) => {
    defer.resolve = rs;
    defer.reject = rj;
  });
  defer.promise.catch(() => {
  });
  return defer;
}

// src/get/get.ts
var get = (object, path) => {
  let value = object;
  const pathArray = typeof path === "string" ? path.split(".") : [path];
  for (let p = 0; p < pathArray.length; p += 1) {
    value = value ? value[pathArray[p]] : void 0;
  }
  return value;
};

// src/assertions/is-empty-array/is-empty-array.ts
var isEmptyArray = (value) => {
  return Array.isArray(value) && value.length === 0;
};

// src/assertions/is-object/is-object.ts
var isObject = (value) => {
  const type = typeof value;
  return value != null && (type === "object" || type === "function") && !Array.isArray(value);
};

// src/assertions/is-empty-object/is-empty-object.ts
var isEmptyObject = (value) => {
  return isObject(value) && Object.keys(value).length === 0;
};

// src/assertions/is-empty/is-empty.ts
var isEmpty = (value) => {
  if (value == null || value === "")
    return true;
  if (Array.isArray(value))
    return isEmptyArray(value);
  if (isObject(value))
    return isEmptyObject(value);
  return false;
};

// src/assertions/is-number/is-number.ts
var isNumber = (value) => {
  return typeof value === "number" && !Number.isNaN(value);
};

// src/assertions/is-nil/is-nil.ts
var isNil = (val) => val === void 0 || val === null;

// src/assertions/is-node/is-node.ts
var isNodeJS = () => typeof module !== "undefined" && module.exports;

// src/dom/add-event/add-event.ts
function addEvent(target, type, callback, options) {
  target.addEventListener(type, callback, options);
  return () => {
    target.removeEventListener(type, callback, options);
  };
}

// src/fp/all/all.ts
var all = (arr, fn = Boolean) => arr.every(fn);

// src/fp/and/and.ts
var and = (a, b) => Boolean(a) && Boolean(b);

// src/fp/any/any.ts
var any = (arr, fn = Boolean) => arr.some(fn);

// src/fp/both/both.ts
var both = (f, g) => (...args) => f(...args) && g(...args);

// src/fp/complement/complement.ts
var complement = (fn) => (...args) => !fn(...args);

// src/fp/either/either.ts
var either = (f, g) => (...args) => f(...args) || g(...args);

// src/fp/last/last.ts
var last = (arr = []) => arr[arr.length - 1];

// src/fp/map-values/map-values.ts
var mapValues = (obj, fn) => Object.keys(obj).reduce((acc, k) => {
  acc[k] = fn(obj[k], k, obj);
  return acc;
}, {});
var deepMapValues = (obj, fn, parentKey) => {
  return Object.keys(obj).reduce((acc, k) => {
    acc[k] = typeof obj[k] === "object" ? deepMapValues(obj[k], fn, parentKey ? `${parentKey}-${k}` : k) : fn(obj[k], `${parentKey}-${k}`, obj);
    return acc;
  }, {});
};

// src/fp/cast-array/cast-array.ts
function castArray(val) {
  return Array.isArray(val) ? val : [val];
}

// src/fp/none/none.ts
var none = (arr, fn = Boolean) => !arr.some(fn);

// src/fp/not/not.ts
var not = (a) => !a;

// src/fp/or/or.ts
var or = (a, b) => a || b;

// src/fp/remove/remove.ts
var remove = (arr, func) => Array.isArray(arr) ? arr.filter(func).reduce((acc, val) => {
  arr.splice(arr.indexOf(val), 1);
  return acc.concat(val);
}, []) : [];

// src/fp/size/size.ts
var size = (val) => Array.isArray(val) ? val.length : val && typeof val === "object" ? val.size || val.length || Object.keys(val).length : typeof val === "string" ? val.length : 0;

// src/fp/sort/sort.ts
var compareString = (left, right) => {
  if (left < right)
    return -1;
  if (left > right)
    return 1;
  return 0;
};
var compareLength = (left, right) => left.length - right.length;
var compareBool = (left, right) => {
  if (left < right)
    return -1;
  if (left > right)
    return 1;
  return 0;
};
var compareNumber = (left, right) => left - right;
var compareReverse = (compare) => (left, right) => compare(right, left);
var compareField = (field, compare) => (left, right) => compare(left[field], right[field]);
var compareCombine = (...comparators) => (left, right) => {
  for (let x = 0; x < comparators.length; x += 1) {
    const compare = comparators[x];
    const res = compare(left, right);
    if (res)
      return res;
  }
  return 0;
};

// src/fp/match/match.ts
var match = (...cases) => {
  const occasion = cases.find(([condition]) => Boolean(condition));
  if (!occasion) {
    throw new Error("No default condition");
  }
  return occasion[1];
};

// src/fp/compose/compose.ts
function compose(...funcs) {
  if (funcs.length === 0) {
    return (arg) => arg;
  }
  if (funcs.length === 1) {
    return funcs[0];
  }
  return funcs.reduce(
    (a, b) => (...args) => a(b(...args))
  );
}

// src/string/camelToKebab/camelToKebab.ts
var camelToKebab = (str) => str.replace(/[\w]([A-Z])/g, (group) => `${group[0]}-${group[1]}`).toLowerCase();

// src/string/camelToSnake/camelToSnake.ts
var camelToSnake = (str) => str.replace(/[\w]([A-Z])/g, (group) => `${group[0]}_${group[1]}`).toLowerCase();

// src/string/kebabToCamel/kebabToCamel.ts
var kebabToCamel = (str) => str.replace(/(-\w)/g, (group) => group[1].toUpperCase());

// src/string/snakeToCamel/snakeToCamel.ts
var snakeToCamel = (str) => str.replace(/(_\w)/g, (group) => group[1].toUpperCase());

// src/string/capitalize/capitalize.ts
var capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

// src/string/uncapitalize/uncapitalize.ts
var uncapitalize = (str) => str.charAt(0).toLowerCase() + str.slice(1);

// src/string/replaceAllOccurrences/replaceAllOccurrences.ts
var replaceAllOccurrences = (initialString, variables, prefix = "{", suffix = "}") => {
  if (typeof initialString === "string" && initialString.length && isObject(variables) && Object.keys(variables).length) {
    let replacedString = initialString;
    Object.entries(variables).forEach(([key, replacement]) => {
      const needle = `${prefix}${key}${suffix}`;
      const re = new RegExp(needle, "gi");
      replacedString = replacedString.replace(re, replacement);
    });
    return replacedString;
  }
  return initialString;
};

// src/array/group-by/group-by.ts
var groupBy = (array, key) => {
  return array.reduce(
    (objectsByKeyValue, obj) => ({
      ...objectsByKeyValue,
      [obj[key]]: (objectsByKeyValue[obj[key]] || []).concat(obj)
    }),
    {}
  );
};

// src/array/range/range.ts
var range = (start, end, step = 1) => {
  const output = [];
  const startEdge = end ? start : 0;
  const endEdge = end ?? start;
  for (let i = startEdge; i < endEdge; i += step) {
    output.push(i);
  }
  return output;
};
export {
  addEvent,
  all,
  and,
  any,
  both,
  camelToKebab,
  camelToSnake,
  capitalize,
  castArray,
  clamp,
  compareBool,
  compareCombine,
  compareField,
  compareLength,
  compareNumber,
  compareReverse,
  compareString,
  complement,
  compose,
  crandom,
  crandomInt,
  createDefer,
  cshuffle,
  deepMapValues,
  either,
  flattenObject,
  get,
  groupBy,
  invlerp,
  isBrowser,
  isEmpty,
  isEmptyArray,
  isEmptyObject,
  isNil,
  isNodeJS,
  isNumber,
  isObject,
  kebabToCamel,
  last,
  lerp,
  mapValues,
  match,
  none,
  not,
  or,
  percentToValue,
  randomInt,
  range,
  remove,
  replaceAllOccurrences,
  shuffle,
  size,
  snakeToCamel,
  toSlug,
  uncapitalize,
  valueToPercent,
  wait
};
